import { useState } from "react";
import { FileDown, X } from "lucide-react";
import { downloadPdf } from "@/lib/download";

const iso = (d) => d.toLocaleDateString("sv-SE");
const range = (key) => {
  const n = new Date(), y = n.getFullYear(), m = n.getMonth();
  if (key === "lastMonth") return [iso(new Date(y, m - 1, 1)), iso(new Date(y, m, 0))];
  if (key === "year") return [iso(new Date(y, 0, 1)), iso(new Date(y, 11, 31))];
  return [iso(new Date(y, m, 1)), iso(new Date(y, m + 1, 0))];
};
const PRESETS = [["month", "Bu ay"], ["lastMonth", "Geçen ay"], ["year", "Bu yıl"]];

export function TransactionsPdfModal({ initialType, initialRange, onClose }) {
  const [type, setType] = useState(initialType), [[start, end], setRange] = useState(initialRange || range("month")), [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault(); setBusy(true);
    await downloadPdf("/transactions/list.pdf", `gelir-gider-${start}_${end}.pdf`, { type, start, end });
    setBusy(false);
  };
  return (
    <div className="modal-backdrop" onClick={onClose}>
      <form className="modal" onSubmit={submit} onClick={(e) => e.stopPropagation()} data-testid="transactions-pdf-modal">
        <div className="modal-head"><div><span className="eyebrow">PDF İNDİR</span><h2>Gelir & Gider listesi</h2></div><button type="button" className="icon-btn" onClick={onClose} data-testid="transactions-pdf-close"><X /></button></div>
        <label>Kayıtlar<select data-testid="transactions-pdf-type" value={type} onChange={(e) => setType(e.target.value)}><option value="all">Tümü</option><option value="income">Gelirler</option><option value="expense">Giderler</option></select></label>
        <div className="pdf-presets">{PRESETS.map(([k, l]) => <button type="button" key={k} className={range(k)[0] === start && range(k)[1] === end ? "filter-btn active" : "filter-btn"} onClick={() => setRange(range(k))} data-testid={`transactions-pdf-preset-${k}`}>{l}</button>)}</div>
        <div className="form-row">
          <label>Başlangıç<input data-testid="transactions-pdf-start" type="date" required value={start} max={end} onChange={(e) => setRange([e.target.value, end])} /></label>
          <label>Bitiş<input data-testid="transactions-pdf-end" type="date" required value={end} min={start} onChange={(e) => setRange([start, e.target.value])} /></label>
        </div>
        <small className="form-hint">PDF, antetli kağıdınıza basılı olarak hazırlanır.</small>
        <div className="modal-actions"><button type="button" className="outline-btn" onClick={onClose} data-testid="transactions-pdf-cancel">Vazgeç</button><button className="primary-btn" disabled={busy} data-testid="transactions-pdf-download"><FileDown size={16} />{busy ? "Hazırlanıyor…" : "PDF indir"}</button></div>
      </form>
    </div>
  );
}
